// extracted by mini-css-extract-plugin
export default {"tableHeader":"AllocationTable_tableHeader__N1iiX"};